const ProductionOrderFacilityWorkloadCounts = (
	json: IProductionOrderFacilityWorkloadCounts | null | undefined,
): IProductionOrderFacilityWorkloadCountsModel => {
	if (!json) {
		return { orders: 0, totalMeals: 0, uniqueMeals: 0 }
	}

	return {
		orders: json.orders ?? 0,
		totalMeals: json.total_meals ?? 0,
		uniqueMeals: json.unique_meals ?? 0,
	}
}

const sumFacilityWorkloadCounts = (
	workloads: IProductionOrderFacilityWorkload[] | undefined,
	key: keyof IProductionOrderFacilityWorkloadCounts,
) => workloads?.reduce((sum, { counts }) => sum + (counts?.[key] ?? 0), 0) ?? 0

const ProductionOrderFacilityWorkload = (
	json: IProductionOrderFacilityWorkload,
): IProductionOrderFacilityWorkloadModel => {
	const { facility_id, name, counts } = json

	return {
		name,
		facilityId: facility_id,
		counts: ProductionOrderFacilityWorkloadCounts(counts),
	}
}

export const ProductionOrderDetailsMeal = (json: IProductionOrderDetailsMeal): IProductionOrderDetailsMealModel => {
	const {
		created_at,
		updated_at,
		addon_category,
		meal_category,
		meal_id,
		variant_id,
		size_id,
		size_name,
		meal_kind,
		meal_type,
		thumb_url,
		overproduction,
		sales_quantity,
		sales_in_fridge,
		detected_changes,
		...rest
	} = json

	return {
		...rest,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		addonCategory: addon_category ?? null,
		mealCategory: meal_category ?? null,
		mealId: meal_id,
		variantId: variant_id,
		sizeId: size_id,
		sizeName: size_name,
		mealKind: meal_kind,
		mealType: meal_type,
		thumbUrl: thumb_url ?? null,
		overproduction,
		salesQuantity: sales_quantity,
		salesInFridge: sales_in_fridge,
		detectedChanges: detected_changes ?? null,
	}
}

export const ProductionOrderDetails = (json: IProductionOrderDetails): IProductionOrderDetailsModel => {
	const {
		business_line,
		order_type,
		delivery_date,
		total_meals,
		total_orders,
		unique_meals,
		facility_workloads,
		items,
		...rest
	} = json

	return {
		...rest,
		businessLine: business_line,
		orderType: order_type,
		deliveryDate: new Date(delivery_date),
		totalMeals: total_meals ?? sumFacilityWorkloadCounts(facility_workloads, 'total_meals'),
		totalOrders: total_orders ?? sumFacilityWorkloadCounts(facility_workloads, 'orders'),
		uniqueMeals: unique_meals ?? sumFacilityWorkloadCounts(facility_workloads, 'unique_meals'),
		facilityWorkloads: facility_workloads?.map(ProductionOrderFacilityWorkload) ?? [],
		items: items ?? [],
	}
}

export const ProductionOrderSummary = (json: IProductionOrderSummary): IProductionOrderSummaryModel => {
	const {
		business_line,
		order_type,
		delivery_date,
		total_meals,
		total_orders,
		unique_meals,
		facility_workloads,
		...rest
	} = json

	return {
		...rest,
		businessLine: business_line,
		orderType: order_type,
		deliveryDate: new Date(delivery_date),
		totalMeals: total_meals ?? sumFacilityWorkloadCounts(facility_workloads, 'total_meals'),
		totalOrders: total_orders ?? sumFacilityWorkloadCounts(facility_workloads, 'orders'),
		uniqueMeals: unique_meals ?? sumFacilityWorkloadCounts(facility_workloads, 'unique_meals'),
		facilityWorkloads: facility_workloads?.map(ProductionOrderFacilityWorkload) ?? [],
	}
}
